<ng-container *ngIf="!!entry">
  <div *ngFor="let key of reflectionProps | keys" [class.hidden]="(entry[key] === undefined || entry[key] === null) && options.hideFields === true"
       class="form-field">

    <ng-container
      *ngIf="!(reflectionProps[key].type === typeEnum.SUB_MODEL || (reflectionProps[key].type === typeEnum.ARRAY && !!reflectionProps[key].subModel))">
      <smart-input [(model)]="entry" [key]="key"></smart-input>
    </ng-container>

    <ng-container *ngIf="reflectionProps[key].type === typeEnum.SUB_MODEL" [ngSwitch]="entry[key]">

      <ng-container *ngSwitchCase="undefined">
        <h4 (click)="addSubmodel(key)">{{key}}
          <mat-icon>add</mat-icon>
        </h4>
      </ng-container>

      <mat-card appearance="outlined" *ngSwitchDefault>
        <h3>{{key}}</h3>
        <default-form [entry]="entry[key]" [options]="options"></default-form>
      </mat-card>

    </ng-container>

    <ng-container
      *ngIf="reflectionProps[key].type === typeEnum.ARRAY && !!reflectionProps[key].subModel && reflectionProps[key].displayAs != displayEnum.HIDDEN">
      <h3>{{key}}</h3>
      <mat-card appearance="outlined" *ngFor="let element of entry[key]; let i = index">
        <h4>{{key}} Element {{i + 1}}</h4>
        <button (click)="removeArraySubmodel(key, i)" class="clearField" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
        <default-form [entry]="element"></default-form>
      </mat-card>
      <div class="button-right-container">
        <button (click)="addArraySubmodel(key)" class="ibexfusion-raised-button" mat-button>Add {{key}} element
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </ng-container>

    <button (click)="clearEntry(key)"
            *ngIf="!reflectionProps[key].mandatory &&
                  reflectionProps[key].type !== typeEnum.SUB_MODEL &&
                  reflectionProps[key].displayAs !== displayEnum.HIDDEN &&
                  reflectionProps[key].displayAs !== displayEnum.READONLY"
            class="clearField" mat-icon-button>
      <mat-icon>delete</mat-icon>
    </button>

  </div>
</ng-container>

<ng-container *ngIf="!entry">
  <mat-card appearance="outlined">
    <mat-card-title>Comming Soon</mat-card-title>
    <p>This Form is not yet editable</p>
  </mat-card>
</ng-container>
